<template>
  <svg viewBox="5 5 40 40">
    <g style="display: inline">
      <path
        class="st0"
        d="M34.39,20.8c0-0.01,0-0.02,0-0.04c0-0.01,0-0.02,0-0.03c-0.01-0.08-0.04-0.15-0.09-0.21c0,0,0-0.01,0-0.01
		c0,0-0.01,0-0.01,0c-0.06-0.06-0.14-0.1-0.23-0.1c-0.01,0-0.02,0-0.03,0c-0.01,0-0.02,0-0.03,0l-9.22,0.88l6.29-8.41
		c0.08-0.11,0.1-0.26,0.03-0.39c-0.06-0.13-0.19-0.2-0.33-0.2h-5.28c-0.13,0-0.24,0.06-0.31,0.17L17.8,23.92
		c-0.01,0.01-0.01,0.03-0.02,0.04c-0.01,0.02-0.02,0.05-0.03,0.07c-0.01,0.03-0.01,0.05-0.01,0.08c0,0.02-0.01,0.03,0,0.05
		c0,0,0.01,0.01,0.01,0.01c0.01,0.08,0.05,0.15,0.11,0.21c0.01,0.01,0.02,0.02,0.03,0.03c0.01,0.01,0.02,0.02,0.03,0.03
		c0.06,0.04,0.13,0.06,0.2,0.06c0.01,0,0.03,0,0.04,0l9.19-0.96l-5.18,7.37l-1.3-1.9c-0.09-0.13-0.26-0.19-0.42-0.14
		c-0.15,0.05-0.26,0.19-0.26,0.36l0.04,4.62c0,0.12,0.06,0.23,0.15,0.29c0.06,0.05,0.14,0.07,0.22,0.07c0.04,0,0.07,0,0.11-0.02
		l4.42-1.34c0.16-0.05,0.26-0.19,0.26-0.35c0-0.16-0.11-0.31-0.26-0.35l-1.96-0.59l11.11-10.5c0,0,0-0.01,0.01-0.01
		C34.34,20.97,34.38,20.89,34.39,20.8z"
      />
    </g>
    <g style="display: inline">
      <path
        d="M11.81,12.98l0.59,4.47l-0.74,0.1l-0.4-3c-1.98,2.84-3.03,6.15-3.03,9.64c0,5.67,2.82,10.94,7.55,14.09l-0.55,0.83
		c-5.01-3.34-8-8.92-8-14.92c0-3.67,1.1-7.15,3.16-10.14l-2.84,0.59L7.4,13.89L11.81,12.98 M12.66,11.78L11.61,12L7.2,12.91
		l-0.98,0.2l0.2,0.98l0.15,0.74l0.2,0.98l0.98-0.2l0.6-0.12c-1.4,2.68-2.13,5.65-2.13,8.7c0,6.34,3.16,12.23,8.44,15.76l0.83,0.55
		l0.55-0.83l0.55-0.83l0.55-0.83l-0.83-0.55c-4.45-2.96-7.11-7.92-7.11-13.26c0-2.29,0.49-4.52,1.43-6.57l0.01,0.07l0.13,0.99
		l0.99-0.13l0.74-0.1l0.99-0.13l-0.13-0.99l-0.59-4.47L12.66,11.78L12.66,11.78z"
      />
      <path
        d="M43.06,24.18c0,4.79-1.86,9.29-5.25,12.67c-3.38,3.38-7.88,5.25-12.67,5.25c-1.82,0-3.61-0.29-5.33-0.82l1.41,2.53
		l-0.66,0.37l-2.19-3.93l4.08-1.9l0.32,0.68l-2.75,1.28c1.65,0.53,3.37,0.81,5.13,0.81c4.52,0,8.77-1.76,11.96-4.95
		c3.19-3.2,4.95-7.44,4.95-11.96H43.06 M44.06,23.18h-1h-1h-1v1c0,4.25-1.66,8.25-4.66,11.26c-3.01,3.01-7,4.66-11.26,4.66
		c-0.68,0-1.37-0.05-2.05-0.14l0.1-0.05l0.91-0.42l-0.42-0.91l-0.32-0.68L22.94,37l-0.91,0.42l-4.08,1.9l-0.97,0.45l0.52,0.94
		l2.19,3.93l0.49,0.87l0.87-0.49l0.66-0.37l0.87-0.49l-0.49-0.87l-0.29-0.52c1.11,0.2,2.23,0.3,3.34,0.3c5.05,0,9.8-1.97,13.38-5.54
		c3.57-3.57,5.54-8.32,5.54-13.38V23.18L44.06,23.18z"
      />
      <path
        d="M25.15,6.26c4.79,0,9.29,1.86,12.67,5.25c2.03,2.03,3.53,4.51,4.4,7.22l1.27-2.59l0.67,0.33l-1.98,4.05l-3.89-2.26
		l0.38-0.65l2.63,1.53c-0.81-2.6-2.24-4.98-4.18-6.92c-3.2-3.19-7.44-4.95-11.96-4.95c-3.91,0-7.73,1.37-10.75,3.85l-0.64-0.77
		C16.96,7.71,21,6.26,25.15,6.26 M25.15,5.26c-4.38,0-8.65,1.53-12.02,4.31l-0.77,0.64l0.64,0.77l0.64,0.77l0.64,0.77l0.77-0.64
		c2.84-2.34,6.43-3.62,10.11-3.62c4.25,0,8.25,1.66,11.26,4.66c1.13,1.13,2.09,2.44,2.83,3.86l-0.07-0.04l-0.87-0.5l-0.5,0.87
		l-0.38,0.65l-0.5,0.86l0.86,0.5l3.89,2.26l0.93,0.54l0.47-0.97l1.98-4.05l0.44-0.9l-0.9-0.44l-0.67-0.33l-0.9-0.44l-0.44,0.9
		l-0.26,0.54c-0.93-2.02-2.22-3.87-3.79-5.44C34.95,7.23,30.2,5.26,25.15,5.26L25.15,5.26z"
      />
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

@Component
export default class IconGroeneStroom extends Vue {}
</script>

<style scoped type="text/css">
.st0 {
  fill: none;
  stroke: #000000;
  stroke-miterlimit: 10;
}
</style>
